import React from 'react';
import { StyledComponentProps, withStyles, Button as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { Cancel } from '../Icons/index';
import clsx from 'clsx';

interface IProps extends StyledComponentProps {
    onClick: (evt:any) => any;
    disabled?: boolean;
    text:string;
    className?:any;
}

const UndoButton = (props: IProps) => {
    return (<MuiButton
        disabled={props.disabled}
        className={clsx(props.className, props.classes.btnRootWithIcon)}
        onClick={props.onClick} 
        variant="contained">
        <div className={props.classes.withLeftIcon}>
            <Cancel className={props.classes.buttonItemIcon}/>
            {props.text}
        </div>
    </MuiButton>)
}


export default withStyles(styles)(UndoButton)